import Wix from './wix-sdk-polyfill';

export default function listenToNavigationChange(store) {
  Wix.addEventListener(Wix.Events.PAGE_NAVIGATION_IN, (payload) => {
    store.dispatch({ type: Wix.Events.PAGE_NAVIGATION_IN, payload });
  });

  Wix.addEventListener(Wix.Events.PAGE_NAVIGATION_OUT, (payload) => {
    store.dispatch({ type: Wix.Events.PAGE_NAVIGATION_OUT, payload });
  });
}
